import { PageInfo } from "@models/ISchema";
import { AdaptedGroup } from "../models";
import { DataReducerType } from "./types";

/**
 * Set the given `Group` as the `group` of the `GroupManager`'s context.
 *
 * @param AdaptedGroup
 * @param DataReducerType
 *
 * @return DataReducerType
 */
export const setGroup = (group: AdaptedGroup, state: DataReducerType): DataReducerType => ({
  ...state,
  group,
});

/**
 * Create an hashmap where the `key` is the `groupId` and the `value` is the
 * `group` itself using the given `AdaptedGroup[]` array and set it as the
 * context's `groupsById`.
 *
 * @param groups AdaptedGroup
 * @param state DataReducerType
 *
 * @return DataReducerType
 */
export const setGroupsById = (groups: AdaptedGroup[], state: DataReducerType): DataReducerType => {
  const groupsById = groups.reduce((acc: Record<string, AdaptedGroup>, group) => {
    if (!(group?.id in acc)) acc[group?.id] = group;
    return acc;
  }, {});
  return { ...state, groupsById };
};

/**
 * Set the given `Groups` as the `groups` of the `GroupManager`'s context.
 *
 * @param AdaptedGroup[]
 * @param DataReducerType
 *
 * @return DataReducerType
 */
export const setGroups = (groups: AdaptedGroup[], state: DataReducerType): DataReducerType => ({
  ...state,
  groups,
});

/**
 * Set the given `GroupPage` as the `groupsPageInfo` of the `GroupManager`'s context.
 *
 * @param PageInfo
 * @param DataReducerType
 *
 * @return DataReducerType
 */
export const setGroupsPageInfo = (
  groupsPageInfo: PageInfo,
  state: DataReducerType,
): DataReducerType => ({ ...state, groupsPageInfo });

export const clean = (state: DataReducerType): DataReducerType => ({
  ...state,
  groups: null,
  groupsById: {},
  groupsPageInfo: {
    hasPreviousPage: false,
    hasNextPage: false,
    page: 0,
    size: 0,
    total: 0,
  },
  group: null,
});
